import React from 'react'
import { useUser, getHelpee } from '@fs/zion-user'
import { Unavailable } from '@fs/zion-error-page'
import { useTranslation } from 'react-i18next'
import { useShowTemple } from '@fs/zion-permissions'
import { useGroupsContext } from '@fs/zion-tree-groups'
import CenteredLoadingSpinner from './CenteredLoadingSpinner'

export default function UnavailableDecorator({ children, isResearcherPage }) {
  const { userLoading, cisId } = useUser(getHelpee)
  const { canAccessFGT, canAccessCET } = useGroupsContext()
  const [isMember, showTempleState] = useShowTemple()
  const [t] = useTranslation()

  const heading = isResearcherPage
    ? t('group-management.research-trees.heading')
    : t('group-management.family-groups.heading')
  const text = isResearcherPage
    ? t('group-management.helper-mode-research-tree-privacy.description')
    : t('group-management.helper-mode-privacy.description')

  if (userLoading || showTempleState === 'loading') return <CenteredLoadingSpinner />

  if (isResearcherPage && !canAccessCET) return <Unavailable />

  // We care about the user being a member because we still need to show ordinances sharing groups even if they can't access family groups
  if (!isResearcherPage && !canAccessFGT && !isMember) return <Unavailable />

  if (cisId) return <Unavailable heading={heading} body={text} />

  return <>{children}</>
}
